import { Component, OnInit } from '@angular/core';
import { InternalMsgService } from '../../../../shared/internal.msg.service';
import { StatusMessagesService } from '../../../../shared/statusmessage.service';
import { SysadminServiceService } from '../../../../shared/sysadmin-service.service';
import { CommonService } from '../../../../shared/common.service';
import { EditUserDto } from '../../../../model/edituserdto';
import { ReturnObject } from '../../../../model/returnobject';

@Component({
  selector: 'sysadmin-edit-role',
  templateUrl: './sysadmin-edit-role.component.html',
  styleUrls: ['./sysadmin-edit-role.component.scss']
})
export class SysadminEditRoleComponent implements OnInit {
  roles: EditUserDto[] = [];
  globalId: string = '';
  firstName: string = '';
  lastName: string = ''
  department: string = '';
  role: string = 'Beställare';
  email: string = '';
  showLoading: boolean = false;

  constructor(
    private sysadminService: SysadminServiceService,
    private common: CommonService,
    private statusMessagesService: StatusMessagesService,
    private msgService: InternalMsgService
  ) { }

  ngOnInit(): void {
    this.getAllManuallyAddedRoles();
  }

  getAllManuallyAddedRoles() {
    this.showLoading = true;
    this.msgService.ontoggleSpinnerSet(true);
    this.sysadminService.getAllManuallyAddedRoles()
      .subscribe((roles: ReturnObject<EditUserDto[]>) => {
        if (roles.isFailure) {
          this.statusMessagesService.showToasterError('Error', roles.failureMessage);
          return;
        }
        this.roles = roles.value;
        this.showLoading = false;
        this.msgService.ontoggleSpinnerSet(false);
      });
  }

  isValuesSet(): boolean {
    return !this.common.isNullOrWhiteSpace(this.globalId)
      && !this.common.isNullOrWhiteSpace(this.firstName)
      && !this.common.isNullOrWhiteSpace(this.lastName)
      && !this.common.isNullOrWhiteSpace(this.department)
      && !this.common.isNullOrWhiteSpace(this.role)
      && !this.common.isNullOrWhiteSpace(this.email)
      && this.email.includes('@')
      && this.email.includes('.');
  }

  addRole() {
    let newRoleItem = new EditUserDto();
    newRoleItem.globalId = this.globalId;
    newRoleItem.name = `${this.lastName.trim()} ${this.firstName.trim()}`;
    newRoleItem.department = this.department;
    newRoleItem.role = this.role;
    newRoleItem.email = this.email;

    this.sysadminService.addRole(newRoleItem)
      .subscribe((msg: ReturnObject<string>) => {
        if (msg.isFailure) {
          this.statusMessagesService.showToasterError('Error', msg.failureMessage);
          return;
        }
        this.getAllManuallyAddedRoles();
        this.statusMessagesService.showToasterInfo('Added', msg.value);
      })
  }

  removeRole(globalId: string) {
    this.sysadminService.removeRole(globalId)
      .subscribe((msg: ReturnObject<string>) => {
        if (msg.isFailure) {
          this.statusMessagesService.showToasterError('Error', msg.failureMessage);
          return;
        }
        this.getAllManuallyAddedRoles();
        this.statusMessagesService.showToasterInfo('Removed', msg.value);
      })
  }
}
